import {createStore, applyMiddleware} from 'redux';
import rootReducer from './reducers';
import thunk from 'redux-thunk';
import {createBrowserHistory} from 'history'

import {routerMiddleware, syncHistoryWithStore} from 'react-router-redux'
// import logger from 'redux-logger'

export const history = createBrowserHistory();
// syncHistoryWithStore(history,store);

// const middlewares = [thunk, routerMiddleware(history),logger];
const middlewares = [thunk, routerMiddleware(history)];

export const configureStore = function(initialState) {
    return createStore(rootReducer,
        applyMiddleware(...middlewares),
        // initialState,
        // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
    );
};
